// extracted by mini-css-extract-plugin
var _1 = "ResetPasswordForm-module__form___Hhi1x";
var _2 = "ResetPasswordForm-module__heading___v8ks7";
export { _1 as "form", _2 as "heading" }
